import { render, staticRenderFns } from "./SciencePatentCountries.vue?vue&type=template&id=0b0ce3cf&scoped=true"
import script from "./SciencePatentCountries.vue?vue&type=script&lang=js"
export * from "./SciencePatentCountries.vue?vue&type=script&lang=js"
import style1 from "./SciencePatentCountries.vue?vue&type=style&index=1&id=0b0ce3cf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0ce3cf",
  null
  
)

export default component.exports